exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-d906f2b6] { margin-bottom: 15px;\n}\n.table-operator[data-v-d906f2b6] { margin-bottom: 15px;\n}\r\n", ""]);

// exports
